module.exports = __webpack_public_path__ + "img/github-logo.ceb2cd27.svg";